<template>
  <div class="scene-option">
    <div class="scene_title blue_header">
      <span>{{ $t('sceneTemplate.lightTripOption') }}</span>
    </div>
    <div class="scene_container">
      <div class="scene-option_item">
        <div class="scene-option_item_label">
          {{ $t('lastLight.brightness') }}:
        </div>
        <el-slider
          v-model="lightProps"
          class="scene-option_slider"
          :min="lightRange.Min"
          :max="100"
          @change="() => onValueChange('light')"
        />
        <div class="scene-option_item_value">
          {{ lightProps }} %
        </div>
      </div>
      <div
        v-if="showTemperature"
        class="scene-option_item"
      >
        <div class="scene-option_item_label">
          {{ $t('lastLight.colorName') }}:
        </div>
        <el-slider
          v-model="temperature"
          class="scene-option_slider"
          :min="optionRange.temperature.Min"
          :max=" optionRange.temperature.Max"
          @change="() => onValueChange('temperature')"
        />
        <div class="scene-option_item_value">
          {{ temperature }}
        </div>
      </div>
      <div
        v-if="showDuv"
        class="scene-option_item"
      >
        <div class="scene-option_item_label">
          DUV:
        </div>
        <el-slider
          v-model="duv"
          class="scene-option_slider"
          :min="optionRange.duv.Min"
          :max="optionRange.duv.Max"
          @change="() => onValueChange('duv')"
        />
        <div class="scene-option_item_value">
          {{ duv }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { transLightToProp, transLightToValue } from '@/utils/actionsHandler';

export default {
  // inject: ["handleSelectionChange", "doCallActionFun","deleteCardFun"],
  props: {
    option: {
      type: Object,
      default: () => ({
        light: 255
      })
    },
    optionRange: {
      type: Object,
      default: () => ({
        light: {
          Max: 255,
          Min: 1
        },
        temperature: {
          Max: 12000,
          Min: 1800
        },
        duv: {
          Max: 8,
          Min: -8
        }
      })
    },
    showDuv: {
      type: Boolean,
      default: false
    },
    showTemperature: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      lightProps: 255,
      temperature: 4000,
      duv: -4,
      lightRange() {
        return {
          Min: 0,
          Max: 255,
        }
      }
    }
  },

  computed: {
    showValue() {
      return this.value;
    }
  },

  watch: {
    option(value) {
      // this.initLight(value);
    },
    device() {
      // this.initOptionRange();
    }
  },

  mounted() {
    this.initLight(this.option);
  },

  methods: {
    onValueChange(type) {
      this.$emit('change', {
        type,
        payload: this.getValue()
      });
    },

    getValue() {
      console.log('this.optionRange', this.optionRange);
      
      return {
        light:  transLightToValue(this.lightProps, this.optionRange?.light?.Max || 255), //  Math.round(255 * (this.lightProps / 100)),
        lightProps: this.lightProps,
        temperature: this.temperature,
        duv: this.duv,
      }
    },

    initLight(value) {
      console.log('this.optionRange initLight', value, this.optionRange);
      const optionRange = this.optionRange;
      const light = (value || { light: 255 }).light;
      const temperature = (value || { temperature: 4000 }).temperature;
      const parsedDuv = Number((value || {}).duv);

      this.lightProps = transLightToProp(light, optionRange.light.Max); // Math.round(light / optionRange.light.Max * 100);
      this.temperature = temperature;
      this.duv = Number.isFinite(parsedDuv) ? parsedDuv : -4;
      this.lightRange = {
        Min: Math.round(optionRange.light.Min / optionRange.light.Max * 100),
        Max: 100
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.scene-option {
  margin-bottom: 50px;

  &_item {
    display: flex;
    width: 400px;
    align-items: center;

    &_label {
      margin-right: 10px;
    }

    &_value {
      width: 40px;
      margin-left: 10px;
    }
  }

  &_slider {
    flex: 1;
  }
}
</style>